import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './BuyPackages.styles';
import { CheckIcon } from '@/components/UI/Icons/Icons';
import { packages } from '@/components/Profile/Business/BuyPackages.constants';
import { ROUTES } from '@/constants/routes';
import { setSuffix } from '@/utils/helpers';
import { useCustomPush } from '@/components/CustomLink/CustomLink.hooks';

export const BuyPackages = () => {
  const { t, i18n } = useTranslation();
  const customPush = useCustomPush();

  function buyPlan() {
    customPush(ROUTES.buyPlan);
  }

  return (
    <S.Box>
      <S.Title $variant="2">{t('pages.cabinet.buy_new_package')}</S.Title>

      <S.List>
        {packages.map(p => (
          <S.Item key={p.id} $bg={p.bg}>
            <S.Name $variant="2">{p.name}</S.Name>
            <S.Price $variant="4">{p.price} AZN</S.Price>
            <S.Adv $variant="1">
              <CheckIcon />{' '}
              {t('pages.cabinet.amount_for_services', { amount: p.price })}
            </S.Adv>
            <S.Adv $variant="1">
              <CheckIcon />
              {t(setSuffix(i18n, p.adsAmount.toString(), 'common.n_ads'), {
                n: p.adsAmount,
              })}
            </S.Adv>
            <S.Adv $variant="1">
              <CheckIcon />{' '}
              {t('pages.cabinet.discount_for_services', {
                discount: p.discount,
              })}
            </S.Adv>
            <S.BuyButton
              isFullWidth
              appearance="secondaryWhite"
              onClick={buyPlan}
            >
              {t('pages.cabinet.plug_in_package', { name: p.name })}
            </S.BuyButton>
          </S.Item>
        ))}
      </S.List>
    </S.Box>
  );
};
